module.exports = __webpack_public_path__ + "img/cargo_driving.fda6640a.svg";